import "@datadog/browser-rum/bundle/datadog-rum";

interface DatadogRum {
  applicationId?: string;
  clientToken?: string;
  service?: string;
  env?: string;
  active?: boolean;
}

/**
 * It initializes RUM(realtime use monitoring) for FE.
 * @param {DatadogRum} datadogRumDetails - The RUM details which include their applicationId, clientToken, service and env details
 */
export function initDatadogRum(datadogRumDetails: DatadogRum) {
  if (
    !datadogRumDetails.applicationId ||
    !datadogRumDetails.clientToken ||
    !datadogRumDetails.service
  ) {
    return;
  }
  window.DD_RUM.init({
    applicationId: datadogRumDetails.applicationId,
    clientToken: datadogRumDetails.clientToken,
    site: "datadoghq.eu",
    service: datadogRumDetails.service,
    env: datadogRumDetails.env,
    version: "",
    sampleRate: 100,
    trackInteractions: true,
    defaultPrivacyLevel: "mask-user-input",
  });
}

/**
 * It starts the Session Replay recording
 */
export function initRumSessionReplay(): void {
  window.DD_RUM.startSessionReplayRecording();
}

/**
 * Allows us to add user information to RUM sessions.
 * @param {string} email - Email id of user
 */
export function setRumUserDetails(email: string): void {
  if (email) {
    window.DD_RUM.setUser({
      email: email,
    });
  }
}
